import { render, staticRenderFns } from "./auth-form-image-captcha.vue?vue&type=template&id=57770c9a&scoped=true"
import script from "./auth-form-image-captcha.vue?vue&type=script&lang=js"
export * from "./auth-form-image-captcha.vue?vue&type=script&lang=js"
import style0 from "./auth-form-image-captcha.vue?vue&type=style&index=0&id=57770c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57770c9a",
  null
  
)

export default component.exports